import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { handleOAuthCallback, isAuthenticated } from "./authService"

function OAuthCallback({setLoggedIn}) {
    const isProcessed = useRef(false);
    const navigate = useNavigate();

    useEffect(() => {
        async function processOAuthResponse() {
            if (isProcessed.current) {
                return;
            }
            isProcessed.current = true;
            try {
                const currentUrl = window.location.href;
                await handleOAuthCallback(currentUrl);

                setLoggedIn(await isAuthenticated());
                navigate("/homepage");
            } catch (error) {
                console.error("Error processing OAuth callback:", error);
            }
        }

        processOAuthResponse();
    }, [])
}

export default OAuthCallback;